// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"styles_appContainer__cg0fD","hideOnSpArticle":"styles_hideOnSpArticle__VvCer"};